export default "__VITE_ASSET__C2Az2RA4__"